<script lang="ts">
import { getLocaleValue } from '@/js/helper/locale.ts';
import { classname } from '@/js/utils.js';
import BaseIcon from '@/js/vue/base/base-icon.vue';
import BaseInputSwitch from '@/js/vue/base/base-switch.vue';

const classCallManager = classname('call-manager');

export default {
  name: 'AppCallManager',
  components: {
    BaseInputSwitch,
    BaseIcon,
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isQuestions: this.modelValue,
    };
  },
  watch: {
    modelValue() {
      this.isQuestions = this.modelValue;
    },
    isQuestions() {
      this.$emit('update:modelValue', this.isQuestions);
    },
  },
  methods: {
    getLocaleValue,
    classCallManager,
  },
};
</script>

<template>
  <div :class="classCallManager()">
    <BaseInputSwitch v-model="isQuestions" :class="classCallManager('call')">
      <div :class="classCallManager('text')">
        <div :class="classCallManager('icon')">
          <BaseIcon type="main" icon="phone" :width="30" :height="30" />
        </div>
        <div :class="classCallManager('title-wrapper')">
          <div :class="classCallManager('title')">
            {{ getLocaleValue('still_have_questions') }}
          </div>
          <div :class="classCallManager('subtitle')">
            {{ getLocaleValue('need_a_call_from_a_manager') }}
          </div>
        </div>
      </div>
    </BaseInputSwitch>
  </div>
</template>

<style lang="scss">
.call-manager {
  display: grid;
  grid-gap: 25px;

  &__text {
    display: flex;
    grid-gap: 19px;
  }

  &__icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 59px;
    height: 59px;
    background-color: #f7f8fa;
    border-radius: 11px;
  }

  &__title-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  &__title {
    font-weight: 500;
    font-size: 18px;
  }

  &__subtitle {
    font-size: 16px;
  }
}
</style>
